import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {checkErrorType} from '../../../utils';
import Error from '../../../common/components/Error/Error';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import PopIn from '../../../common/components/PopIn';
import {CancelButton, FooterRow, GradientCol, TitleButton} from '../../../common/components/StyledComp';
import Tooltip from '../../../common/components/Tooltip';
import {ERROR_TYPE_EMAIL_ALREADY_USED} from '../../../common/constants';
import {GRAPHQL_MUTATION_REGISTER_ADMIN} from '../../../common/queries/users';
import {validateEmail} from '../../../utils';
import '../assets/style.scss';

const MarginTooltip = styled.div`
  margin-left: 15px;
`;

const AddAdmin = props => {
  const {t} = props;
  const initialUser = {
    firstName: '',
    lastName: '',
    email: '',
    password: Math.random()
      .toString(36)
      .slice(2),
    postalCode: '34000',
    civility: 'Other',
    birthDate: null,
  };
  const [modalVisible, setModalVisible] = useState(false);
  const [newUser, setNewUser] = useState(initialUser);
  const [submitted, setSubmitted] = useState(false);

  const addAdmin = register => {
    setSubmitted(true);
    if (newUser.lastName !== '' && newUser.firstName !== '' && newUser.email !== '' && validateEmail(newUser.email)) {
      register({variables: {userInput: newUser}})
        .then(() => {
          setModalVisible(false);
          setSubmitted(false);
          setNewUser(initialUser);
        });
    }
  };

  return (
    <Mutation mutation={GRAPHQL_MUTATION_REGISTER_ADMIN} refetchQueries={['users']}>
      {(register, {error, loading}) => {
        const existingEmailError = checkErrorType(error, ERROR_TYPE_EMAIL_ALREADY_USED);
        return (
          <div>
            <TitleButton onClick={() => setModalVisible(true)} className="title-btn">
              {t('addUser.addAdmin')}
            </TitleButton>
            <PopIn title={t('addUser.addAdmin')} visible={modalVisible} setModalVisible={setModalVisible} size={'lg'}>
              <Container>
                <Row className="info-row">
                  <Col xs={{span: 8, offset: 2}}>
                    <MandatoryInput
                      title={`${t('dataTable.lastname')} : `}
                      name="lastName"
                      value={newUser.lastName}
                      show={submitted && newUser.lastName === ''}
                      onChange={(name, value) => setNewUser({...newUser, lastName: value})}
                    />
                    <MandatoryInput
                      title={`${t('dataTable.firstname')} : `}
                      name="firstName"
                      value={newUser.firstName}
                      show={submitted && newUser.firstName === ''}
                      onChange={(name, value) => setNewUser({...newUser, firstName: value})}
                    />
                    <MandatoryInput
                      title={`${t('dataTable.email')} : `}
                      name="email"
                      value={newUser.email}
                      show={(submitted && newUser.email === '') || (submitted && !validateEmail(newUser.email))}
                      onChange={(name, value) => {
                        setNewUser({...newUser, email: value});
                      }}
                      customText={t('addUser.wrongEmail')}
                    />
                    <MarginTooltip>
                      <Tooltip show={existingEmailError} color="red">
                        {t('addUser.existingEmail')}
                      </Tooltip>
                    </MarginTooltip>
                  </Col>
                </Row>
                <FooterRow>
                  <GradientCol sm={{span: 6, offset: 3}}>
                    <Error error={!existingEmailError && error}/>
                    <div className="popin-buttons">
                      <TitleButton disabled={loading} onClick={() => addAdmin(register)}>
                        {t('addUser.save')}
                      </TitleButton>
                      <CancelButton disabled={loading} onClick={() => setModalVisible(false)} style={{marginTop: 0, width: 'auto'}}>
                        {t('addUser.cancel')}
                      </CancelButton>
                    </div>
                  </GradientCol>
                </FooterRow>
              </Container>
            </PopIn>
          </div>
        );
      }}
    </Mutation>
  );
};

AddAdmin.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('admin')(AddAdmin);
